module.exports = __webpack_public_path__ + "static/media/merah.dd54c12d.svg";